import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
@Injectable({
  providedIn: "root",
})
export class DataRefreshService {
  private refreshProjectsSubject = new Subject<void>();

  // Method to trigger a refresh
  triggerProjectsRefresh() {
    this.refreshProjectsSubject.next();
  }

  // Observable to subscribe to for refresh notifications
  getProjectsRefreshListener() {
    return this.refreshProjectsSubject.asObservable();
  }
}
